export function ADD_FILE_TO_DELETE (state, id) {
  state.filesToDelete.push(id)
}

export function RESET_FILES_TO_DELETE (state) {
  state.filesToDelete.length = 0
}
